const getCanonicalSourcePath = (canonical: string | null | undefined): string | null => {
  if (!canonical) {
    return null;
  }

  try {
    const sourcePath = new URL(canonical).pathname.toLowerCase().replace(/\/+$/, "");

    return sourcePath || null;
  } catch {
    return null;
  }
};

export const getCommunicationSignupSourcePath = (
  canonical: string | null | undefined,
  fallbackPathname: string
): string => getCanonicalSourcePath(canonical) ?? fallbackPathname;
